import { MantineProvider, MantineThemeOverride } from "@mantine/core";
import { Notifications } from "@mantine/notifications";
import { MedplumClient } from "@medplum/core";
import { MedplumProvider } from "@medplum/react";
import { Provider } from "react-redux";
import { createRoot } from "react-dom/client";
import { RouterProvider, createBrowserRouter } from "react-router-dom";
import { PersistGate } from "redux-persist/integration/react";
import { App } from "./App";
import { getConfig } from "./config";
import { store, persistor } from "./store";
import "./index.css";

const excludeAuthUrl = [
  "/signin",
  "/oauth",
  "/launch",
  "/healthconnect-ai",
  "/healthconnect-chat",
  "/healthconnect-form",
  "/healthconnect-referral",

  "/healthconnect-epic",
];
export async function initApp(): Promise<void> {
  const config = getConfig();

  const medplum = new MedplumClient({
    baseUrl: config.baseUrl,
    cacheTime: 1000,
    autoBatchTime: 100,
    onUnauthenticated: () => {
       if (
         !excludeAuthUrl.some((url) => window.location.pathname.includes(url))
       ) {
         window.location.href =
           "/signin?next=" +
           encodeURIComponent(
             window.location.pathname + window.location.search
           );
       }
    },
  });

  const theme: MantineThemeOverride = {
    headings: {
      sizes: {
        h1: {
          fontSize: "1.125rem",
          fontWeight: 500,
          lineHeight: 2.0,
        },
      },
    },
    fontSizes: {
      xs: "0.6875rem",
      sm: "0.875rem",
      md: "0.875rem",
      lg: "1.0rem",
      xl: "1.125rem",
      xxl: "1.625rem",
    },
  };

  const router = createBrowserRouter([{ path: "*", element: <App /> }]);

  const navigate = (path: string): Promise<void> => router.navigate(path);

  const root = createRoot(document.getElementById("root") as HTMLElement);
  root.render(
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <MedplumProvider medplum={medplum} navigate={navigate}>
          <MantineProvider theme={theme} withGlobalStyles withNormalizeCSS>
            <Notifications position="bottom-right" />
            <RouterProvider router={router} />
          </MantineProvider>
        </MedplumProvider>
      </PersistGate>
    </Provider>
  );
}

if (process.env.NODE_ENV !== "test") {
  initApp().catch(console.error);
}
